<template>
  <div class="help">
    <Nav></Nav>
    <!-- <HomeNav currentTab="0"></HomeNav> -->
    <div class="aboutJdxb-wrap">
      <div class="aboutJdxb">
        <div class="about">
          <div class="back" @click="goClick">
            <div class="back-icon"></div>
            返回
          </div>
          <div class="guide-title-icon"></div>
          <div class="step-wrap">
            <div class="step-icon"></div>
            <div class="step-text">需客户端与设备端结合使用</div>
            <div class="step-icon step-icon2"></div>
            <div class="step-text">客户端可访问设备端设备及服务</div>
          </div>
          <div class="wrap1">
            <div class="fun1-icon"></div>
          </div>
          <div class="wrap2">
            <div class="wrap2-title">使用指南</div>
            <div class="list-title">
              <div class="list-icon"></div>
              客户端
            </div>
            <div class="list-line"></div>
            <div class="list-item">
              <div class="item itemm" @click="showAboutClick(1)">
                <div class="item-icon"></div>
                <div class="item-text">Web网页端</div>
              </div>
              <div class="item itemm" @click="showAboutClick(2)">
                <div class="item-icon item-icon2"></div>
                <div class="item-text">Windows</div>
              </div>
              <div class="item itemm" @click="showAboutClick(3)">
                <div class="item-icon item-icon5"></div>
                <div class="item-text">macOS</div>
              </div>
              <div class="item itemm" @click="showAboutClick(4)">
                <div class="item-icon item-icon6"></div>
                <div class="item-text">Android</div>
              </div>
              <div class="item itemm" @click="showAboutClick(5)">
                <div class="item-icon item-icon3"></div>
                <div class="item-text">iOS</div>
              </div>
              <div class="item itemm" @click="showAboutClick(6)">
                <div class="item-icon item-icon4"></div>
                <div class="item-text">微信小程序</div>
              </div>
            </div>
            <div class="list-title">
              <div class="list-icon"></div>
              设备端
            </div>
            <div class="list-line"></div>
            <div class="list-item">
              <div class="item itemm" @click="showAboutClick(7)">
                <div class="item-icon item-icon7"></div>
                <div class="item-text">NAS</div>
              </div>
              <div class="item itemm" @click="showAboutClick(8)">
                <div class="item-icon item-icon2"></div>
                <div class="item-text">Windows</div>
              </div>
              <div class="item itemm" @click="showAboutClick(10)">
                <div class="item-icon item-icon5"></div>
                <div class="item-text">macOS</div>
              </div>
              <!--                <div class="item itemm">-->
              <!--                    <div class="item-icon item-icon10"></div>-->
              <!--                    <div class="item-text">路由</div>-->
              <!--                </div>-->
            </div>
            <div class="list-title">
              <div class="list-icon"></div>
              高级服务
            </div>
            <div class="list-line"></div>
            <div class="list-item">
              <div class="item itemm" @click="showAboutClick(9)">
                <div class="item-icon item-icon11"></div>
                <div class="item-text">工具箱</div>
              </div>
              <div class="item itemm" @click="goVipClick">
                <div class="item-icon item-icon12"></div>
                <div class="item-text">自定义服务</div>
              </div>
            </div>
          </div>
        </div>
        <About
          v-if="isShowAbout"
          :isShowAbout="isShowAbout"
          @closeAboutAlert="closeAboutAlert"
        ></About>
        <AboutTool
          v-if="isShowAbout == 9"
          :isShowAbout="isShowAbout"
          @closeAboutAlert="closeAboutAlert"
        ></AboutTool>
      </div>
    </div>
  </div>
</template>

<script>
import Nav from "@/components/Common/Nav.vue";
import HomeNav from "@/components/Common/HomeNav.vue";
import About from "@/components/remote/About.vue";
import AboutTool from "@/components/remote/AboutTool.vue";
export default {
  components: {
    Nav,
    HomeNav,
    About,
    AboutTool,
  },
  data: function () {
    return {
      isShowAbout: 0,
    };
  },
  methods: {
    goVipClick: function () {
      let _that = this;
      _that.$router.push("/home/vipabout");
    },
    showAboutClick: function (data) {
      let _that = this;
      _that.isShowAbout = data;
    },
    closeAboutAlert: function () {
      let _that = this;
      _that.isShowAbout = 0;
    },
    goClick: function () {
      this.$router.back(-1);
    },
  },
};
</script>
<style lang="less" scoped>
.help {
  background-color: #f3f5f7;
}
.aboutJdxb-wrap {
  width: 960px;
  height: 510px;
  overflow: hidden;
  background-color: #f3f5f7;
}
.aboutJdxb {
  margin: 0 auto;
  width: 940px;
  height: 502px;
  box-sizing: border-box;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  border: 1px solid #dddddd;
  border-radius: 4px;
  overflow: hidden;
  .about {
    width: 936px;
    height: 482px;
    overflow-y: scroll;
    background: linear-gradient(
      180deg,
      #ffffff 0%,
      rgba(255, 255, 255, 0) 87.39%
    );
  }
  .back {
    display: inline-block;
    padding-left: 22px;
    padding-top: 15px;
    padding-right: 22px;
    padding-bottom: 15px;
    vertical-align: top;
    font-size: 14px;
    line-height: 16px;
    color: #666666;
    cursor: pointer;
    .back-icon {
      display: inline-block;
      margin-right: 6px;
      vertical-align: top;
      width: 14px;
      height: 14px;
      background-image: url("../assets/remote/back.svg");
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
  }
  .guide-title-icon {
    margin: 0 auto;
    width: 136px;
    height: 32px;
    background-image: url("../assets/remote/guide1.svg");
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  .step-wrap {
    margin-top: 38px;
    text-align: center;
    font-size: 14px;
    line-height: 24px;
    color: #4a4a4a;

    .step-icon,
    .step-text {
      display: inline-block;
      vertical-align: top;
    }
    .step-icon {
      margin-right: 8px;
      width: 24px;
      height: 24px;
      background-image: url("../assets/remote/guide2.svg");
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    .step-icon2 {
      margin-left: 65px;
      background-image: url("../assets/remote/guide3.svg");
    }
  }
  .wrap1 {
    padding-top: 1px;
    margin: 0 auto;
    margin-top: 16px;
    width: 759px;
    height: 337px;
    background: #ffffff;
    border: 1px solid #dbdee2;
    border-radius: 16px;
    box-sizing: border-box;
    overflow: hidden;
    .fun1-icon {
      margin: 0 auto;
      margin-top: 2px;
      width: 590px;
      height: 334px;
      background-image: url("../assets/remote/guide4.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
  }
  .wrap2 {
    position: relative;
    padding-top: 44px;
    margin: 0 auto;
    margin-top: 42px;
    width: 759px;
    height: 403px;
    background-color: #ffffff;
    border: 1px solid #dbdee2;
    border-radius: 16px;
    box-sizing: border-box;
    .wrap2-title {
      position: absolute;
      left: 50%;
      top: -22px;
      transform: translate(-50%, 0);
      width: 186px;
      height: 42px;
      line-height: 42px;
      background-color: #dde7f2;
      border-radius: 48px;
      font-weight: 500;
      font-size: 20px;
      color: #243a5d;
      text-align: center;
    }
    .list-title {
      margin-left: 68px;
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      color: #1a1a1a;
      .list-icon {
        display: inline-block;
        margin-right: 6px;
        vertical-align: top;
        width: 16px;
        height: 16px;
        background-image: url("../assets/remote/about6.svg");
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }
    }

    .list-line {
      margin-top: 4px;
      margin-left: 56px;
      width: 620px;
      height: 1px;
      background-image: linear-gradient(
        88deg,
        #243a5d 15%,
        rgba(36, 58, 93, 0) 110%
      );
    }

    .list-item {
      margin-left: 86px;
      padding-top: 8px;
      padding-bottom: 16px;
      .item {
        display: inline-block;
        margin-right: 20px;
        vertical-align: top;
        width: 125px;
        height: 46px;
        line-height: 46px;
        box-sizing: border-box;
        background-color: #ffffff;
        border-radius: 3px;
        cursor: pointer;

        .item-icon {
          display: inline-block;
          margin-right: 4px;
          vertical-align: top;
          margin-top: 12px;
          width: 20px;
          height: 20px;
          background-image: url("../assets/remote/abouti1.svg");
          background-repeat: no-repeat;
          background-size: 100% 100%;
        }
        .item-icon2 {
          background-image: url("../assets/remote/abouti2.svg");
        }
        .item-icon3 {
          background-image: url("../assets/remote/abouti3.svg");
        }
        .item-icon4 {
          background-image: url("../assets/remote/abouti4.svg");
        }
        .item-icon5 {
          background-image: url("../assets/remote/abouti5.svg");
        }
        .item-icon6 {
          background-image: url("../assets/remote/abouti6.svg");
        }
        .item-icon7 {
          background-image: url("../assets/remote/abouti7.svg");
        }
        .item-icon9 {
          background-image: url("../assets/remote/abouti9.svg");
        }
        .item-icon10 {
          background-image: url("../assets/remote/abouti10.svg");
        }
        .item-icon11 {
          background-image: url("../assets/remote/abouti11.svg");
        }
        .item-icon12 {
          background-image: url("../assets/remote/abouti12.svg");
        }

        .item-text {
          display: inline-block;
          vertical-align: top;
          font-size: 14px;
        }
      }
      .item:hover {
        background-image: url("../assets/remote/about7.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }
      .itemm {
        padding-left: 16px;
      }
      .items {
        margin-left: 20px;
      }
      .items2 {
        margin-left: 2px;
      }
      .items3 {
        margin-left: 28px;
      }
    }
  }
  .guide-text {
    margin-top: 27px;
    margin-left: 24px;
    margin-bottom: 24px;
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
    color: #1a1a1a;
    .guide-icon {
      display: inline-block;
      margin-left: 12px;
      margin-top: 3px;
      vertical-align: top;
      width: 29px;
      height: 16px;
      background-image: url("../assets/remote/about5.svg");
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    .guide-icon2 {
      display: inline-block;
      margin-left: -1px;
      margin-top: 12px;
      vertical-align: top;
      width: 770px;
      height: 1px;
      background-color: rgba(20, 57, 119, 0.2);
    }
  }
}
</style>